import { SortDescriptor } from "react-aria-components";

import { SORT_CONFIG, USERS_SORT_KEYS } from "../constants";
import { UsersListUser } from "../types";

export const sortUsers = (items: UsersListUser[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const sortColumn = sortDescriptor.column as USERS_SORT_KEYS;
  const key = SORT_CONFIG[sortColumn];

  if (!key) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    const valueA = String(a[key] ?? "");
    const valueB = String(b[key] ?? "");

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
